import { z } from "zod";

/** Client may identify a booking; the server owns amount, currency, and status. */
export const createQrphPaymentSchema = z.object({
  bookingId: z.string().uuid(),
});

export type CreateQrphPaymentInput = z.infer<typeof createQrphPaymentSchema>;

/**
 * Maya (0350). `returnUrl` is where PayMongo sends the client after Maya; the
 * server accepts only a booking page on one of our own origins.
 */
export const createMayaPaymentSchema = z.object({
  bookingId: z.string().uuid(),
  returnUrl: z.string().url().max(500),
});

export type CreateMayaPaymentInput = z.infer<typeof createMayaPaymentSchema>;

/** Local demo control. The server still authenticates and owns the booking. */
export const settleStubPaymentSchema = z.object({
  bookingId: z.string().uuid(),
});

export type SettleStubPaymentInput = z.infer<typeof settleStubPaymentSchema>;

/**
 * Machine-triggered worker call; the queue is the durable input.
 *
 * `.default({})` is load-bearing, not tidiness. `withValidation` parses
 * `envelope.data`, and the only caller — the `payment-fulfillment` pg_cron job
 * in `0026_paymongo_qrph.sql` — posts a bare `body := '{}'::jsonb`, so `data`
 * arrives `undefined`. Without a default that is a 422 VALIDATION_FAILED on
 * every single run, which means `process_payment_job` never drains the queue
 * and NO online payment is ever marked paid. Measured on the local stack
 * 2026-08-04: the worker answered 422 the first minute the cron could reach it
 * at all. `runPayrollSchema` already carries the same default for the same
 * reason — a machine caller with no payload is the normal case for cron.
 */
export const paymentWorkerSchema = z.object({}).default({});

export type PaymentWorkerInput = z.infer<typeof paymentWorkerSchema>;
